import { Button } from 'antd';
import React from 'react';
import '../../styles/components/MarketPlace/CityWiseJobs.scss';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

function BottomButton({
  buttonText,
  callBackFunction,
  disabled = false,
  customClass,
  loader,
  loading = false,
}) {
  return (
    <div className="proceed-button">
      <Button
        className={customClass || (!disabled ? 'proceed-btn' : 'proceed-btn disabled')}
        onClick={() => callBackFunction()}
        disabled={disabled}
        loading={loading}
      >
        {buttonText}
        {loader}
      </Button>
    </div>
  );
}

BottomButton.defaultProps = {
  buttonText: '',
  disabled: false,
  callBackFunction: noop,
  customClass: '',
  loader: null,
  loading: false,
};
BottomButton.propTypes = {
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
  callBackFunction: PropTypes.func,
  customClass: PropTypes.string,
  loader: PropTypes.node,
  loading: PropTypes.bool,
};

export default BottomButton;
